export const SET_INDUSTRIES = 'SET_INDUSTRIES';

export function setIndustries(payload) {
  return { type: SET_INDUSTRIES, payload };
}
